import PageHead from "@/components/common/PageHead";
import config from "@/config";

/**
 * About page component describing PriceMe's mission and features
 */
const About = () => {
    return (
        <>
            <PageHead
                title="PriceMe | About"
                description="Learn about PriceMe - the real estate guessing game that tests your market knowledge"
                canonicalUrl={`${config.BASE_URL}/about`}
            />
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <h1 className="mb-4 text-center">About PriceMe</h1>

                        <div className="mb-5">
                            <h2 className="h4 mb-3">What is PriceMe?</h2>
                            <p className="lead">
                                PriceMe is an interactive real estate guessing game that challenges your knowledge of
                                property values. Scroll through spectacular homes from around the world and test your
                                market intuition by guessing the sale price.
                            </p>
                            {/*
                            <p className="lead">
                                PriceMe is an interactive real estate guessing game that challenges your knowledge of
                                local property values. Test your market intuition by guessing the sale prices of
                                recently sold homes in your area.
                            </p>
                            */}
                        </div>

                        <div className="mb-5">
                            <h2 className="h4 mb-3">How It Works</h2>
                            <p>
                                We pick out spectacular properties from around the world. You get 6 tries to guess the
                                price.
                            </p>
                            {/*
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item border-0 px-0">
                                    <strong>Classic Mode:</strong> Guess prices of 3 recently sold properties
                                </li>
                                <li className="list-group-item border-0 px-0">
                                    <strong>Daily Puzzle:</strong> New challenging property every day
                                </li>
                                <li className="list-group-item border-0 px-0">
                                    <strong>Social Mode:</strong> Share results and compete with friends
                                </li>
                            </ul>
                            */}
                        </div>

                        <div className="mb-5">
                            <h2 className="h4 mb-3">Scoring</h2>
                            <p>
                                Points are awarded based on accuracy. The closer your guess to the actual sale price,
                                the more points you earn. Compete on our leaderboards and track your progress over time.
                            </p>
                        </div>

                        <div className="text-center">
                            <h2 className="h4 mb-3">Ready to Play?</h2>
                            <p className="mb-4">Join thousands of players testing their real estate knowledge daily.</p>
                            <div className="d-flex gap-3 justify-content-center flex-wrap">
                                <a href="/" className="btn btn-primary">
                                    Play Now
                                </a>
                            </div>
                            {/*
                            <div className="d-flex gap-3 justify-content-center flex-wrap">
                                <a href="/classic" className="btn btn-primary">
                                    Play Classic
                                </a>
                                <a href="/puzzle" className="btn btn-outline-primary">
                                    Daily Puzzle
                                </a>
                            </div>
                            */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default About;
